import React from 'react';
import { FaRegWindowRestore } from 'react-icons/fa6';
import { FiPause, FiPlay, FiX } from 'react-icons/fi';
import { TbHeadphones } from 'react-icons/tb';
import Tooltip from '../Tooltip/Tooltip';

/**
 * Compact floating chip while the main player window is minimized.
 */
export default function AudioPlayerMiniDock({
  title,
  statusLabel = 'Now playing',
  metaLine = '',
  playing = false,
  onTogglePlay,
  onRestore,
  onClose,
  className = '',
}) {
  const rootClass = ['audio-mini-dock', className].filter(Boolean).join(' ');
  const playLabel = playing ? 'Pause' : 'Play';

  return (
    <div className={rootClass} role="region" aria-label="Minimized audio player">
      <span className="audio-mini-dock__art" aria-hidden>
        <TbHeadphones />
      </span>
      <div className="audio-mini-dock__meta">
        <span className="audio-mini-dock__status">{statusLabel}</span>
        <p className="audio-mini-dock__title" title={title}>
          {title}
        </p>
        {metaLine ? <p className="audio-mini-dock__meta-line">{metaLine}</p> : null}
      </div>
      <div className="audio-mini-dock__actions">
        {onTogglePlay ? (
          <Tooltip text={playLabel} position="top">
            <button
              type="button"
              className="audio-mini-dock__btn audio-mini-dock__btn--play"
              onClick={onTogglePlay}
              aria-label={playLabel}
            >
              {playing ? <FiPause aria-hidden /> : <FiPlay aria-hidden />}
            </button>
          </Tooltip>
        ) : null}
        <Tooltip text="Restore player" position="top">
          <button type="button" className="audio-mini-dock__btn" onClick={onRestore} aria-label="Restore player">
            <FaRegWindowRestore aria-hidden />
          </button>
        </Tooltip>
        {onClose ? (
          <Tooltip text="Close player" position="top">
            <button type="button" className="audio-mini-dock__btn" onClick={onClose} aria-label="Close player">
              <FiX aria-hidden />
            </button>
          </Tooltip>
        ) : null}
      </div>
    </div>
  );
}
